import { createSelector } from '@reduxjs/toolkit';
import { MEDIA_ASSET_STATUS } from '@socialive/common';
import selectMediaUploadAssetList from './selectMediaUploadAssetList';

const COMPLETED_STATES = [MEDIA_ASSET_STATUS.COMPLETED, MEDIA_ASSET_STATUS.FAILED];

export default createSelector(
  selectMediaUploadAssetList,
  (uploads) => uploads.length > 0 && uploads.every((upload) => COMPLETED_STATES.includes(upload.status))
);
